import { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Features from './components/Features';
import Products from './components/Products';
import Plans from './components/Plans';
import Consultation from './components/Consultation';
import Comparison from './components/Comparison';
import Order from './components/Order';
import About from './components/About';
import Testimonials from './components/Testimonials';
import Footer from './components/Footer';

export default function Home() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar scrolled={scrolled} />
      <Hero />
      <Features />
      <Products />
      <Plans />
      <Consultation />
      <Comparison />
      <Order />
      <About />
      <Testimonials />
      <Footer />
    </div>
  );
}
